var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.view == 'metodos-de-pago')?_c('view-component',{attrs:{"model_name":"payment_method"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }